var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{attrs:{"loading":_vm.$store.state.loading.processing,"text":_vm.$store.state.loading.text}})}
var staticRenderFns = []

export { render, staticRenderFns }